// --------------------------------
// ------ Tracking Locations ------ snake_case
// --------------------------------

import type {
	AboutPageLocations,
	BlogPageLocations,
	GetFiberPageLocations,
	ResidentialPageLocations,
	ServiceAreaPageLocations,
	ServiceAreaPageLocationsMap,
	ServiceAreasPageLocations
} from '@/types/ga4/tracking-locations'

// ---------------------------------
// ------ Layout Locations ---------
// ---------------------------------
export const ALERT_BANNER = 'alert_banner'

// ----------------------------------
// ------ Other Page Locations ------
// ----------------------------------
export const LOGIN_PAGE = 'login_page'
export const FORGOT_PASSWORD_PAGE = 'forgot_password_page'
export const LATE_PAYMENTS_PAGE = 'late_payments_page'
export const UNACTIVATED_USER_PAGE = 'unactivated_user_page'
export const CONTACT_PAGE = 'contact_page'
export const MAINTENANCE_PAGE = 'maintenance_page'
export const OUTAGE_PAGE = 'outage_page'

// ----------------------------------------
// ------ Residential Page Locations ------
// ----------------------------------------
export const RESIDENTIAL_HERO_LOCATION = 'residential_hero'
export const RESIDENTIAL_TESTIMONIALS_LOCATION = 'residential_testimonials'
export const RESIDENTIAL_FAQ = 'residential_faq'
export const RESIDENTIAL_BLOG_CAROUSEL = 'residential_blog_carousel'
export const RESIDENTIAL_CTA_BANNER = 'residential_cta_banner'

export const RESIDENTIAL_PAGE_LOCATIONS: ResidentialPageLocations = {
	hero: RESIDENTIAL_HERO_LOCATION,
	ctaBanner: RESIDENTIAL_CTA_BANNER,
	testimonials: RESIDENTIAL_TESTIMONIALS_LOCATION,
	faq: RESIDENTIAL_FAQ,
	blogCarousel: RESIDENTIAL_BLOG_CAROUSEL
} as const satisfies ResidentialPageLocations

// ----------------------------------
// ------ About Page Locations ------
// ----------------------------------
export const ABOUT_HERO = 'about_hero'
export const ABOUT_TESTIMONIALS = 'about_testimonials'
export const ABOUT_FAQ = 'about_faq'
export const ABOUT_BLOG_CAROUSEL = 'about_blog_carousel'
export const ABOUT_CTA_BANNER = 'about_cta_banner'

export const ABOUT_PAGE_LOCATIONS: AboutPageLocations = {
	hero: ABOUT_HERO,
	testimonials: ABOUT_TESTIMONIALS,
	faq: ABOUT_FAQ,
	blogCarousel: ABOUT_BLOG_CAROUSEL,
	ctaBanner: ABOUT_CTA_BANNER
} as const satisfies AboutPageLocations

// ---------------------------------
// ------ Blog Page Locations ------
// ---------------------------------
export const BLOG_LIST = 'blog_list'
export const BLOG_ARTICLE = 'blog_article'

export const BLOG_PAGE_LOCATIONS: BlogPageLocations = {
	list: BLOG_LIST,
	article: BLOG_ARTICLE
} as const satisfies BlogPageLocations

// ---------------------------------------
// ------ Get Fiber Pages Locations ------
// ---------------------------------------
export const GET_FIBER_MAIN = 'get_fiber_main'
export const GET_FIBER_INTERNET_AVAILABLE = 'get_fiber_internet_available'
export const GET_FIBER_INTERNET_UNAVAILABLE = 'get_fiber_internet_unavailable'
export const GET_FIBER_UNDER_CONSTRUCTION = 'get_fiber_under_construction'
export const GET_FIBER_MOVING_IN = 'get_fiber_moving_in'
export const GET_FIBER_ALREADY_REGISTERED = 'get_fiber_already_registered'
export const GET_FIBER_COMPLETE = 'get_fiber_signup_complete'

export const GET_FIBER_PAGE_LOCATIONS: GetFiberPageLocations = {
	default: GET_FIBER_MAIN,
	available: GET_FIBER_INTERNET_AVAILABLE,
	unavailable: GET_FIBER_INTERNET_UNAVAILABLE,
	underConstruction: GET_FIBER_UNDER_CONSTRUCTION,
	movingIn: GET_FIBER_MOVING_IN,
	alreadyRegistered: GET_FIBER_ALREADY_REGISTERED,
	complete: GET_FIBER_COMPLETE
} as const satisfies GetFiberPageLocations

// ----------------------------------------------
// ------ Servie Areas List Page Locations ------
// ----------------------------------------------
export const SERVICE_AREAS_MAIN = 'service_areas_main'
export const SERVICE_AREAS_HERO = 'service_areas_hero'
export const SERVICE_AREAS_CTA_BANNER = 'service_areas_cta_banner'

export const SERVICE_AREAS_PAGE_LOCATIONS: ServiceAreasPageLocations = {
	main: SERVICE_AREAS_MAIN,
	hero: SERVICE_AREAS_HERO,
	ctaBanner: SERVICE_AREAS_CTA_BANNER
} as const satisfies ServiceAreasPageLocations

// -----------------------------------------
// ------ Service Area Page Locations ------
// -----------------------------------------

// ------ Parker, CO ------
export const PARKER_HERO = 'parker_hero'
export const PARKER_TESTIMONIALS = 'parker_testimonials'
export const PARKER_FAQ = 'parker_faq'
export const PARKER_BLOG_CAROUSEL = 'parker_blog_carousel'
export const PARKER_CTA_BANNER = 'parker_cta_banner'

export const PARKER_PAGE_LOCATIONS: ServiceAreaPageLocations = {
	hero: PARKER_HERO,
	testimonials: PARKER_TESTIMONIALS,
	faq: PARKER_FAQ,
	blogCarousel: PARKER_BLOG_CAROUSEL,
	ctaBanner: PARKER_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------ Elizabeth, CO ------
export const ELIZABETH_HERO = 'elizabeth_hero'
export const ELIZABETH_TESTIMONIALS = 'elizabeth_testimonials'
export const ELIZABETH_FAQ = 'elizabeth_faq'
export const ELIZABETH_BLOG_CAROUSEL = 'elizabeth_blog_carousel'
export const ELIZABETH_CTA_BANNER = 'elizabeth_cta_banner'

export const ELIZABETH_PAGE_LOCATIONS: ServiceAreaPageLocations = {
	hero: ELIZABETH_HERO,
	testimonials: ELIZABETH_TESTIMONIALS,
	faq: ELIZABETH_FAQ,
	blogCarousel: ELIZABETH_BLOG_CAROUSEL,
	ctaBanner: ELIZABETH_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------ Kiowa, CO ------
export const KIOWA_HERO = 'kiowa_hero'
export const KIOWA_TESTIMONIALS = 'kiowa_testimonials'
export const KIOWA_FAQ = 'kiowa_faq'
export const KIOWA_BLOG_CAROUSEL = 'kiowa_blog_carousel'
export const KIOWA_CTA_BANNER = 'kiowa_cta_banner'

export const KIOWA_PAGE_LOCATIONS: ServiceAreaPageLocations = {
	hero: KIOWA_HERO,
	testimonials: KIOWA_TESTIMONIALS,
	faq: KIOWA_FAQ,
	blogCarousel: KIOWA_BLOG_CAROUSEL,
	ctaBanner: KIOWA_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------ Livermore, CO ------
export const LIVERMORE_HERO = 'livermore_hero'
export const LIVERMORE_TESTIMONIALS = 'livermore_testimonials'
export const LIVERMORE_FAQ = 'livermore_faq'
export const LIVERMORE_BLOG_CAROUSEL = 'livermore_blog_carousel'
export const LIVERMORE_CTA_BANNER = 'livermore_cta_banner'

export const LIVERMORE_PAGE_LOCATIONS: ServiceAreaPageLocations = {
	hero: LIVERMORE_HERO,
	testimonials: LIVERMORE_TESTIMONIALS,
	faq: LIVERMORE_FAQ,
	blogCarousel: LIVERMORE_BLOG_CAROUSEL,
	ctaBanner: LIVERMORE_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------ Franktown, CO ------
export const FRANKTOWN_HERO = 'franktown_hero'
export const FRANKTOWN_TESTIMONIALS = 'franktown_testimonials'
export const FRANKTOWN_FAQ = 'franktown_faq'
export const FRANKTOWN_BLOG_CAROUSEL = 'franktown_blog_carousel'
export const FRANKTOWN_CTA_BANNER = 'franktown_cta_banner'

export const FRANKTOWN_PAGE_LOCATIONS: ServiceAreaPageLocations = {
	hero: FRANKTOWN_HERO,
	testimonials: FRANKTOWN_TESTIMONIALS,
	faq: FRANKTOWN_FAQ,
	blogCarousel: FRANKTOWN_BLOG_CAROUSEL,
	ctaBanner: FRANKTOWN_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------ Unknown Service Area ------
export const UNKNOWN_SERVICE_AREA_HERO = 'unknown_service_area_hero'
export const UNKNOWN_SERVICE_AREA_TESTIMONIALS = 'unknown_service_area_testimonials'
export const UNKNOWN_SERVICE_AREA_FAQ = 'unknown_service_area_faq'
export const UNKNOWN_SERVICE_AREA_BLOG_CAROUSEL = 'unknown_service_area_blog_carousel'
export const UNKNOWN_SERVICE_AREA_CTA_BANNER = 'unknown_service_area_cta_banner'
export const UNKNOWN_SERVICE_AREA = 'unknown_service_area'

export const UNKNOWN_SERVICE_AREA_LOCATIONS: ServiceAreaPageLocations = {
	hero: UNKNOWN_SERVICE_AREA_HERO,
	testimonials: UNKNOWN_SERVICE_AREA_TESTIMONIALS,
	faq: UNKNOWN_SERVICE_AREA_FAQ,
	blogCarousel: UNKNOWN_SERVICE_AREA_BLOG_CAROUSEL,
	ctaBanner: UNKNOWN_SERVICE_AREA_CTA_BANNER
} as const satisfies ServiceAreaPageLocations

// ------------------------------------
// ------ Page Locations Mappers ------
// ------------------------------------

export const SERVICE_AREA_PAGE_LOCATIONS_MAP: ServiceAreaPageLocationsMap = {
	'Parker, CO': PARKER_PAGE_LOCATIONS,
	'Elizabeth, CO': ELIZABETH_PAGE_LOCATIONS,
	'Kiowa, CO': KIOWA_PAGE_LOCATIONS,
	'Livermore, CO': LIVERMORE_PAGE_LOCATIONS,
	'Franktown, CO': FRANKTOWN_PAGE_LOCATIONS,
	'unknown': UNKNOWN_SERVICE_AREA_LOCATIONS
} as const satisfies ServiceAreaPageLocationsMap
